import { useState } from "react";
import { Link } from "react-router-dom";

export default function PublicHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  const nav = [
    { label: "Features",  href: "/#features" },
    { label: "Pricing",   href: "/#pricing"  },
    { label: "Security",  href: "/#security" },
    { label: "Contact",   to:   "/contact"   },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-strong border-b border-white/[0.07]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex items-center justify-between h-16">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 group">
            <div className="w-9 h-9 glass-gold rounded-xl flex items-center justify-center shadow-sm group-hover:shadow-luxury-gold/20 group-hover:shadow-md transition-all">
              <svg style={{width:"18px",height:"18px"}} className="text-luxury-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <div className="leading-none">
              <span className="text-luxury-text font-bold text-lg tracking-tight">
                Tax<span className="text-luxury-gold">Vault</span>
              </span>
              <span className="block text-luxury-muted text-[10px] font-medium tracking-widest uppercase">Global</span>
            </div>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-0.5">
            {nav.map(item =>
              item.to ? (
                <Link key={item.label} to={item.to}
                  className="px-4 py-2 text-sm font-medium text-luxury-secondary hover:text-luxury-text rounded-xl hover:glass-thin transition-all duration-200">
                  {item.label}
                </Link>
              ) : (
                <a key={item.label} href={item.href}
                  className="px-4 py-2 text-sm font-medium text-luxury-secondary hover:text-luxury-text rounded-xl hover:glass-thin transition-all duration-200">
                  {item.label}
                </a>
              )
            )}
          </nav>

          {/* Auth buttons */}
          <div className="hidden md:flex items-center gap-2.5">
            <Link to="/login"
              className="px-4 py-2 text-sm font-semibold text-luxury-secondary glass rounded-xl hover:border-luxury-gold/30 hover:text-luxury-gold transition-all duration-200">
              Log In
            </Link>
            <Link to="/register"
              className="px-4 py-2 text-sm font-bold text-white rounded-xl transition-all duration-200 active:scale-95 hover:opacity-90 hover:shadow-lg hover:shadow-luxury-gold/25"
              style={{background:"linear-gradient(135deg,#D4AF37 0%,#B8940A 100%)",boxShadow:"0 2px 12px rgba(212,175,55,0.20)"}}>
              Get Started Free
            </Link>
          </div>

          {/* Mobile burger */}
          <button onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden p-2.5 rounded-xl text-luxury-secondary hover:text-luxury-gold hover:glass-thin transition-all">
            {menuOpen ? (
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden glass-strong border-t border-white/[0.06] px-5 py-4 space-y-1">
          {nav.map(item =>
            item.to ? (
              <Link key={item.label} to={item.to} onClick={() => setMenuOpen(false)}
                className="block px-4 py-2.5 text-sm font-medium text-luxury-secondary hover:text-luxury-text hover:glass-thin rounded-xl transition-all">
                {item.label}
              </Link>
            ) : (
              <a key={item.label} href={item.href} onClick={() => setMenuOpen(false)}
                className="block px-4 py-2.5 text-sm font-medium text-luxury-secondary hover:text-luxury-text hover:glass-thin rounded-xl transition-all">
                {item.label}
              </a>
            )
          )}
          <div className="pt-3 flex flex-col gap-2 border-t border-white/[0.06] mt-2">
            <Link to="/login" onClick={() => setMenuOpen(false)}
              className="w-full text-center py-2.5 text-sm font-semibold text-luxury-secondary glass rounded-xl hover:text-luxury-gold transition-all">
              Log In
            </Link>
            <Link to="/register" onClick={() => setMenuOpen(false)}
              className="w-full text-center py-2.5 text-sm font-bold text-white rounded-xl transition-all active:scale-95"
              style={{background:"linear-gradient(135deg,#D4AF37 0%,#B8940A 100%)"}}>
              Get Started Free
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
